import DamagePhotoModal from "./damage-photo-modal";
import DamageFilterModal from "./damage-filter-modal";

import "./damage-modals.scss";


const DamageModals = {
    Photo: DamagePhotoModal,
    Filter: DamageFilterModal
}

export default DamageModals;